import React from 'react';

// Named export!
export const POISelectedIdContext = React.createContext();
